export const TABLE_IDENTIFIER_FW_PORTFOLIO_ID = 1;
export const TABLE_IDENTIFIER_FW_ORDER_ID = 2;
export const TABLE_IDENTIFIER_FW_SUBMISSION_ID = 3;
export const TABLE_IDENTIFIER_FW_UNDERWRITING_TOOLS_ID = 4;
export const TABLE_IDENTIFIER_IPR_UNDERWRITING_TOOLS_ID = 5;
export const TABLE_IDENTIFIER_FW_SAVED_QUOTES_ID = 6;
export const TABLE_IDENTIFIER_FW_CLAIM_NOTIFICATIONS_ID = 7;
export const TABLE_IDENTIFIER_FW_REFERRALS_ID = 10;
export const TABLE_IDENTIFIER_FW_COVERHODLER_PORTFOLIO_ID = 13;
export const TABLE_IDENTIFIER_FW_COVERHODLER_WORK_IN_PROGRESS_ID = 14;
export const TABLE_IDENTIFIER_FW_COVERHODLER_REFERRALS_ID = 15;
export const TABLE_IDENTIFIER_FW_COVERHODLER_SAVED_QUOTES_ID = 16;
export const TABLE_IDENTIFIER_FW_COVERHODLER_ORDER_SUBMISSION_ID = 17;
export const TABLE_IDENTIFIER_FW_RENEWAL_ID = 18;
